import { useSelector } from 'react-redux';
import { navSelector } from 'common/store/modules/competition-nav/selectors';

/**
 * Using the nav selector to target elements in the store, return the
 * competitionId, compseason object and round object that we should be using
 * when rendering information based upon the competition nav's current set
 * filters
 *
 * @returns {object} - Contains the comptitionId, compSeason object and round object
 */
export function useGetCurrentCompFilters() {
    const nav = useSelector(navSelector);

    const compSeason = useSelector((state) => state.competitionNavV2.season);
    const round = useSelector((state) => state.competitionNavV2.round);

    const roundLoadError = useSelector(
        (state) => state.competitionNavV2.round.error
    );

    return {
        competitionId: nav?.competition?.id,
        compSeason,
        round,
        roundLoadError
    };
}
